import { lazy } from 'react'

import { authRoles } from '../../../auth/authRoles'
import Loadable from '../../base/components/Template/Loadable/Loadable'

const AppVentaRegistro = Loadable(lazy(() => import('./view/VentaRegistro')))
const AppVentaOfflineRegistro = Loadable(lazy(() => import('./view/VentaRegistroOffline')))
const AppVentaGestion = Loadable(lazy(() => import('./view/VentaGestion')))
const AppVentaGestionOffline = Loadable(lazy(() => import('./view/VentaGestionOffline')))
export const ventasRoutesMap = {
  registro: {
    name: 'Registrar Venta',
    path: '/ventas/registro',
  },
  registroOffline: {
    name: 'Registrar Venta Offline',
    path: '/ventas/registro-offline',
  },
  gestion: {
    name: 'Gestión de Ventas',
    path: '/ventas/gestion',
  },
  gestionOffline: {
    name: 'Gestión de Ventas Offline',
    path: '/ventas/gestion-offline',
  },
}
const ventasRoutes = [
  {
    path: '/ventas/registro',
    element: <AppVentaRegistro />,
    auth: authRoles.admin,
  },
  {
    path: ventasRoutesMap.registroOffline.path,
    element: <AppVentaOfflineRegistro />,
    auth: authRoles.admin,
  },
  {
    path: '/ventas/gestion',
    element: <AppVentaGestion />,
    auth: authRoles.admin,
  },
  {
    path: ventasRoutesMap.gestionOffline.path,
    element: <AppVentaGestionOffline />,
    auth: authRoles.admin,
  },
]

export default ventasRoutes
